export const NEW_ENTITY_QUERY_PARAM = 'newentity';
export const NEW_ENTITY_QUERY_PARAM_VALUE = 'true';

export const DISCLAIMER_TEXT_QUERY_KEY_PREFIX = 'disclaimer-text';
